import React from "react";
import { Modal } from "antd";
import PackingListCainiaoPrinter from "@/services/print/packinglist/PackingListCainiaoPrinter";
import OrderDTO from "@/dto/order/OrderDTO";
import { useModalStore } from "@/hooks/Modal/hooks";
import PrintPackingListModal from "../../dialogs/PrintPackingListDialog/PrintPackingListModal";
import { checkShopIdsEnabledAutoPrint } from "@/scenes/more/AutoPrint/services";
import { useGlobalStore } from "@/store/hooks";
import { uniq } from "lodash";
import { AutoPrintTaskType } from "@/services/api/autoPrint";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";

interface UsePrintPackListClickProps {
    getSelectedOrders: () => OrderDTO[];

    printSuccessCallback?: () => void;
}

const usePrintPackListClick = (props: UsePrintPackListClickProps) => {
    const { getSelectedOrders, printSuccessCallback } = props;

    const globalStore = useGlobalStore();
    const modalStore = useModalStore();

    const handlePrint = async () => {
        const selectedOrders = getSelectedOrders();

        if (selectedOrders.length === 0) {
            return;
        }

        if (!PackingListCainiaoPrinter.isReady()) {
            PackingListCainiaoPrinter.openDownloadPluginDialog();
            return;
        }

        const shopIds = uniq(selectedOrders.map((it) => it.shopId));
        const shops = shopIds.map((shopId) => globalStore.shopMapping.get(shopId));

        const showConfirm = selectedOrders.length === 1;

        const next = await checkShopIdsEnabledAutoPrint(shops, showConfirm, AutoPrintTaskType.PACKING_LIST);

        if (!next) {
            return;
        }

        const isSomePackingListPrinted = selectedOrders.some((order) => order.isPackingListPrinted);

        if (isSomePackingListPrinted) {
            Modal.confirm({
                title: "所选订单中部分订单已打印发货单，是否继续打印？",
                onOk: (close) => {
                    modalStore.openModal(PrintPackingListModal, {
                        orders: selectedOrders,
                        printSuccessCallback,
                        shops,
                    });

                    close();
                },
                focusable: { autoFocusButton: "ok" },
            });
        } else {
            modalStore.openModal(PrintPackingListModal, {
                orders: selectedOrders,
                printSuccessCallback,
                shops,
            });
        }
    };

    return {
        handlePrint,
    };
};

export default usePrintPackListClick;
